// my-theme.ts
const myTheme = {
  font: {
    primary: `'Helvetica', sans-serif`,
    secondary: `'Helvetica', sans-serif`,
    // secondary: `'apparel', sans-serif`,
    color: {
      heading: '#1D1E1B',
      heading_orange: '#F2B420',
    },
  },
  colors: {
    primary: '#F2B420',
    body: '#FEFBF4',
    body2: '#FBF5E8',
    black: '#000',
    white: '#fff',
    whiteSmoke: '#f3f3f3',
    lightGray: '#ECECEC',
    grey1: 'rgba(0, 0, 0, 0.6)',
    bg: '#F5F5F5',
    darkText: '#0D0D0D',
    gray2: '#E7E7E7',
    gray3: '#8E8E8E',
    gray4: '#606060',
    gray5: '#DDDDDD',
    gray6: '#d9d9d9',
    gray7: '#9CA2A3',
    gray8: '#dedede',
    gray9: '#404040',
    gray10: '#858585',
    lightBlue: '#0067FF',
    blue: '#1D1E1B',
    red: '#EE1C1C',
    darkRed: '#DE2E2E',
    green: '#2EB67D',
    orange: '#EE761C',
    yellow: '#F2B420',
  },

  fontSize: {
    sm: '1.2rem',
    md: '1.4rem',
    lg: '1.6rem',
    xl: '1.8rem',
  },
  borderRadius: {
    sm: '0.2rem',
    md: '0.4rem',
    lg: '0.6rem',
    xl: '0.8rem',
  },
  container: {
    sm: '20rem',
    md: '30rem',
    lg: '40rem',
    xl: '50rem',
  },
  statusColors: {
    green: {
      bg: '#ECF9F3',
      color: '#2EB67D',
    },
    orange: {
      bg: '#FFEDD3',
      color: '#EE761C',
    },
    gray: {
      bg: '#E7E7E7',
      color: '#5F5F5F',
    },
    red: {
      bg: '#FFEAEA',
      color: '#FF0505',
    },
    blue: {
      bg: '#D1E5FF',
      color: '#0067FF',
    },
    pink: {
      bg: '#FFEAFC',
      color: '#FF28A9',
    },
    naviblue: {
      bg: '#DDEFFF',
      color: '#1E61E3',
    },
    violet: {
      bg: '#DDEDFF',
      color: '#221EE3',
    },
    purple: {
      bg: '#F9EAFF',
      color: '#C728FF',
    },
    darkblue: {
      bg: 'rgba(102, 152, 227, 0.19)',
      color: '#002B80',
    },
    yellow: {
      bg: 'rgba(251, 245, 232, 1)',
      color: '#F2B420',
    },
    darkPink: {
      bg: '#FAD5E1',
      color: '#E5175C',
    },
    pinkTint: {
      bg: '#FAD5E1',
      color: '#858585',
    },
  },
  button: {
    primary: {
      color: '#1D1E1B',
      bg: '#F2B420',
      hover: '#f7ae00',
    },
  },
};

export { myTheme };
